module.exports = __webpack_public_path__ + "img/contract_complete.7c2fcdb9.svg";